import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex md:grid md:grid-cols-5 gap-3 md:gap-4 overflow-x-auto md:overflow-visible no-scrollbar">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group shrink-0 w-32 md:w-auto flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-5 transition-all duration-300 hover:border-primary-300 hover:-translate-y-1"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <span className="text-sm font-semibold text-foreground-900">{cat.name}</span>
            <span className="hidden md:block text-center text-xs leading-relaxed text-foreground-400 line-clamp-2">
              {cat.desc}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}